import { render } from "./SidebarMenu.vue?vue&type=template&id=33b12b00&scoped=true"
import script from "./SidebarMenu.js?vue&type=script&lang=js"
export * from "./SidebarMenu.js?vue&type=script&lang=js"

import "./SidebarMenu.scss?vue&type=style&index=0&id=33b12b00&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./SidebarMenu.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FUser%2FSidebarMenu%2FSidebarMenu.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b12b00"]])

export default __exports__